import { IDefaultContext } from "interfaces/context";

export const DefaultContext: IDefaultContext = {
  state: {},
  actions: {},
};
